module.exports = __webpack_public_path__ + "static/img/part2img.fe179db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/community/part2img.png
// module id = vc2c
// module chunks = 1